import React, { useState, useRef, useEffect } from "react";
import useAuth from "../../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";


  const ViewBroadcastLinkedZap = (props) => {

    const {broadcastId} = props;
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

  const [linkedZaps, setLinkedZaps] = useState([]);
  const [linkedZapsBroadCast, setLinkedZapsBroadCast] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingOperation, setLoadingOperation] = useState(false);
  useEffect(() => {

    const loadData = async () => {
      setLoading(true);
      loadAssocLinkedZap();
      loadLinkedZap().then(() => {
        setLoading(false);

      });
    }

    loadData();

  }, []);
  const loadLinkedZap = async () => {
    let response = await getApi("/api/v1/linkedZap/list", []);

    setLinkedZaps(response.lista);
  };

  const loadAssocLinkedZap = async () => {
    let response = await getApi("/api/v1/wpbroadcast/assoc/linkedzap/list/" + broadcastId, []);

    setLinkedZapsBroadCast(response.lista);
  };


  const toggleSelecionada = async (id) => {
    if (loadingOperation == true) {
      return;
    }
    setLoadingOperation(true);
    const isAlreadyAssociated = linkedZapsBroadCast.some(
      (item) => item.linked_whatsapp_act_id === id
    );

    const operationType = isAlreadyAssociated ? 'remove' : 'add';
    try {
      let response = await postApi("/api/v1/wpbroadcast/assoc/linkedzap", {
        'broadcast_id': broadcastId,
        'linked_whatsapp_act_id': id,
        'operation_type': operationType // Dinâmico aqui
      });


      // 3. Atualiza as listas após o sucesso
      await loadAssocLinkedZap();

      if (response.status == 'fail') {
        window.alert(response.message)
      }

    } catch (error) {
      console.error("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoadingOperation(false);
    }


  };



  return (
         <div style={{ padding: 16, borderRadius: 12, background: '#fff', boxShadow: '0 6px 20px rgba(0,0,0,0.04)' }}>
                  <div style={{ fontWeight: 700, color: '#222', marginBottom: 12 }}>Contas Associadas</div>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                      {linkedZaps.map((linkedzap) => {
              // Verificação dinâmica: checa se o ID do Zap atual existe na lista da campanha
              const estaNoBroadCast = linkedZapsBroadCast.some(
                (item) => item.linked_whatsapp_act_id === linkedzap.id
              );

              return (
                <div
                  key={linkedzap.id} // Corrigido de linkedZaps.id para linkedzap.id
                  onClick={() => toggleSelecionada(linkedzap.id)}

                  style={{
                    background: estaNoBroadCast ? notifyColor : "#fff",
                    border: estaNoBroadCast ? `3px solid ${notifyColor}` : "2px solid #e0e0e0",
                    borderRadius: 20,
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                    width: 380,
                    minHeight: 180,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    position: "relative",
                    padding: "24px 18px",
                  }}
                >
                  {/* Círculo com foto */}
                  <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: `3px solid ${estaNoBroadCast ? "#fff" : notifyColor}`,
                      marginBottom: 16,
                      background: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative"
                    }}
                  >
                    <img
                      src={linkedzap.profilePictureUrl}
                      alt={linkedzap.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                    {/* Indicador de Status Online (Pulsação Verde) */}
                    <span
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                        right: "-8px",
                        width: 48,
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          background: "rgba(123, 138, 108, 0.8)",
                          animation: linkedzap.connected ? 'pulseVerde 1.2s infinite' : 'pulseVermelho 1.2s infinite',
                        }}

                      ></span>
                      <span
                        style={{
                          position: "relative",
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          background: linkedzap.connected ? "#28c76f" : "#ff0000",
                          border: linkedzap.connected ? "1px solid #28c76f" : "1px solid #ff0000",
                          zIndex: 1,
                        }}
                      ></span>
                    </span>
                  </div>

                  {/* Nome da conta */}
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: estaNoBroadCast ? "#fff" : "#005c53",
                      marginBottom: 6,
                      textAlign: "center",
                    }}
                  >
                    {linkedzap.name}
                  </div>

                  {/* Número da conta */}
                  <div
                    style={{
                      fontSize: 16,
                      color: estaNoBroadCast ? "#fff" : "#333",
                      marginBottom: 16,
                      textAlign: "center",
                    }}
                  >
                    {linkedzap.whatsapp_id}
                  </div>

                  {/* Botão de Ação */}
                  <div
                    style={{
                      width: "80%",
                      margin: "0 auto",
                      marginTop: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        width: "100%",
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "none",
                        background: estaNoBroadCast ? "#fff" : notifyColor,
                        color: estaNoBroadCast ? notifyColor : "#fff",
                        fontWeight: "bold",
                        fontSize: 16,
                        cursor: "pointer",
                        boxShadow: estaNoBroadCast
                          ? "0 2px 8px rgba(0,92,83,0.10)"
                          : "0 1px 4px rgba(0,0,0,0.07)",
                        transition: "all 0.2s",
                        outline: estaNoBroadCast ? `2px solid #fff` : "none",
                      }}
                      disabled={loading}
                      onClick={(e) => {
                        e.stopPropagation(); // Evita disparar o clique do card pai
                        toggleSelecionada(linkedzap.id);
                      }}
                    >
                      {estaNoBroadCast ? "Selecionada" : "Selecionar"}
                    </button>

                    {loadingOperation  && <Loader />}
                  </div>
                </div>
              );
            })}
        
                  </div>
                        {loading  && <Loader />}
                  {/* bulk vincular removed - individual toggle available */}
                </div>
          
  );
};

export default ViewBroadcastLinkedZap;